import Mutations from '../../odata/mutations';

export default { ...new Mutations('playBook'), ...new Mutations('playBooks') };
